import React from "react";
import styled, { css } from "styled-components";
import { tabFocus, padding, colors, getTextStyle, contentMaxWidth } from "@utdanningsdirektoratet/lisa-tokens";
import { Container, FlexColumn, FlexRow, Icon, Text, getContentHorizontalPadding } from "@utdanningsdirektoratet/lisa";

export interface Props {
	systemmeldinger: string[];
}

export const SystemmeldingAccordion = (props: Props) => {
	return (
		<Details open={true}>
			<Summary numberOfSystemmeldinger={props.systemmeldinger.length} />
			<FlexColumn className="mt-12 mx-8">
				{props.systemmeldinger.map((melding, idx) => (
					<SystemmeldingFlexRow className="my-8 p-16" valign="start" key={idx}>
						<Icon className="mr-12 mt-8" type="circle_small" iconColor="oransje500" />
						<Text>{melding}</Text>
					</SystemmeldingFlexRow>
				))}
			</FlexColumn>
		</Details>
	);
};

interface SummaryProps {
	numberOfSystemmeldinger: number;
}

const Summary = (props: SummaryProps) => {
	return (
		<StyledSummary>
			<StyledFlexRow className="my-4">
				<Icon className="mx-4" type={"warning"} />
				<Text textStyle="bodyBold">Systemmelding ({props.numberOfSystemmeldinger})</Text>
			</StyledFlexRow>
			<Container className="mr-40">
				<StyledChevron type="chevron" direction="down" />
			</Container>
		</StyledSummary>
	);
};

const wrapperCss = css`
	max-width: ${contentMaxWidth}px;
	${getContentHorizontalPadding(false)}
	margin: 0 auto;
	width: 100%;
`;

const StyledFlexRow = styled(FlexRow)`
	${wrapperCss}
`;

const StyledChevron = styled(Icon)``;

const StyledSummary = styled.summary`
	display: flex;
	justify-content: space-between;
	align-items: center;
	${getTextStyle("bodyBold")}
	list-style-type: none;
	cursor: pointer;
	${padding("y", 16)}
	overflow-wrap: anywhere;

	background-color: ${colors.oransje400};
	&::-webkit-details-marker {
		display: none;
	}
	&:hover {
		background-color: ${colors.oransje600};
	}

	${tabFocus()}
`;

const Details = styled.details`
	${getTextStyle("body")}
	position: relative;
	background-color: ${colors.oransje300};

	&[open] {
		padding-bottom: 10px;
		${StyledSummary} {
			${StyledChevron} {
				transform: rotate(180deg);
			}
		}
	}
`;

const SystemmeldingFlexRow = styled(FlexRow)`
	background-color: ${colors.oransje200};
	${wrapperCss}
`;
